import { isEmpty, isNil } from 'lodash';

import { CommunicationDeviceName } from '../../../communication/communication-device/communication-device/communication-device-name';
import { UserPrivateData } from '../user-private-data';

import { GetClientIdOrPhoneOutput } from './interfaces';

export const getClientIdOrPhone = (userPrivateData: UserPrivateData): GetClientIdOrPhoneOutput | undefined => {
  if (isNil(userPrivateData)) {
    return undefined;
  }

  const preferSoftPhone = userPrivateData
    .getDevices()
    ?.getDevices()
    .map((z) => z.getType())
    .includes(CommunicationDeviceName.softPhone);

  if (preferSoftPhone) {
    return {
      type: 'clientId',
      value: userPrivateData.getId(),
      routableAddress: `client:${userPrivateData.getId()}`,
    };
  }

  const phone = userPrivateData.getUSLocalPhone();
  if (isEmpty(phone)) {
    return undefined;
  }

  return {
    type: 'phone',
    value: phone!,
    routableAddress: phone!,
  };
};
